import { render } from "./Cursos.vue?vue&type=template&id=7048a9c7&scoped=true"
import script from "./Cursos.vue?vue&type=script&lang=js"
export * from "./Cursos.vue?vue&type=script&lang=js"

import "./Cursos.vue?vue&type=style&index=0&id=7048a9c7&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7048a9c7"]])

export default __exports__